import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Provider } from 'mobx-react';
import AccessModalContent from './AccessModalContent/AccessModalContent';
import { GlobalAccessModalStore } from './GlobalAccessModalStore';
function GlobalAccessModal(props) {
    const { entities, type, isOpen, ...rest } = props;
    const [accessStore, setAccessStore] = useState(null);
    useEffect(() => {
        setAccessStore(isOpen ? new GlobalAccessModalStore(entities, type) : null);
    }, [isOpen]);
    if (!accessStore) {
        return null;
    }
    return (_jsx(Provider, { accessStore: accessStore, children: _jsx(AccessModalContent, { isOpen: isOpen, ...rest }) }));
}
export default GlobalAccessModal;
